import { createTheme } from '@mui/material';

/** Shared visual language for staff and family screens. */
export const appTheme = createTheme({
  palette: {
    primary: { main: '#174c43', dark: '#103c35', light: '#e8f3ef' },
    secondary: { main: '#315b87' },
    background: { default: '#f4f6f8', paper: '#ffffff' },
    text: { primary: '#202e3b', secondary: '#596979' },
    divider: '#e2e8ed',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Segoe UI", system-ui, -apple-system, sans-serif',
    h4: { fontSize: '2rem', fontWeight: 700, letterSpacing: '-0.035em' },
    h5: { fontSize: '1.35rem', fontWeight: 650, letterSpacing: '-0.02em' },
    h6: { fontSize: '1.1rem', fontWeight: 650 },
    subtitle1: { fontWeight: 600 },
    body1: { lineHeight: 1.65 },
    body2: { lineHeight: 1.6 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { margin: 0 },
        '*': { boxSizing: 'border-box' },
        'a, button, summary, [role="button"]': { WebkitTapHighlightColor: 'transparent' },
        ':focus-visible': { outline: '3px solid #315b87', outlineOffset: 3 },
        '@media (prefers-reduced-motion: reduce)': {
          '*, *::before, *::after': { animation: 'none !important', transition: 'none !important' },
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { minHeight: 44, paddingInline: 18, borderRadius: 8 } },
    },
    MuiIconButton: { styleOverrides: { root: { minHeight: 44, minWidth: 44 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8, backgroundColor: '#ffffff' } } },
    MuiInputBase: { styleOverrides: { root: { minHeight: 44 } } },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { outlined: { borderColor: '#e2e8ed' } },
    },
    MuiAlert: { styleOverrides: { root: { borderRadius: 10 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 600, borderRadius: 6 } } },
    MuiTableCell: {
      styleOverrides: {
        head: { backgroundColor: '#f6f8fa', fontWeight: 650, color: '#596979' },
        root: { borderColor: '#e2e8ed', padding: '14px 16px' },
      },
    },
  },
});
